enum AuBicValue {
  REVOAU32 = 'REVOAU32',
}

export default AuBicValue;
